export const MenuList = [
  {
    id: 1,
    title: "About",
    url: "#",
  },
  {
    id: 2,
    title: "Technology",
    url: 2,
  },
  {
    id: 3,
    title: "Use cases",
    url: 3,
  },
  {
    id: 4,
    title: "Market",
    url: 4,
  },
  {
    id: 5,
    title: "Resources",
    url: 5,
  },
  {
    id: 6,
    title: "Roadmap",
    url: 6,
  },
  {
    id: 7,
    title: "Partners",
    url: 7,
  },
  {
    id: 8,
    title: "Team",
    url: 8,
  },
];
